import axios from "axios";
import { useContext, useEffect, useReducer, useState } from "react";
import { Store } from "../Store";
import { getError } from "../utils";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default function useSampleTableTypes() {
  const { dispatch: ctxDispatch, state } = useContext(Store);
  const { tableTypes, userInfo } = state; // Use sampleTableTypes from the store
  const [{ loading, error }, dispatch] = useReducer(reducer, {
    loading: false,
    error: "",
  });

  const [loadSampleTableTypes, setLoadSampleTableTypes] = useState(false);

  const fetchSampleTableTypes = async () => {
    try {
      dispatch({ type: "FETCH_REQUEST" });
      const { data } = await axios.get(`/api/sampletabletypes`, {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      }); // Fetch from the sampleTableTypes API

      dispatch({ type: "FETCH_SUCCESS", payload: data });
      ctxDispatch({
        type: "TABLE_TYPES_UPDATED",
        payload: data || [],
      });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL", payload: getError(err) });
    }
  };

  useEffect(() => {
    if (userInfo && !tableTypes) {
      fetchSampleTableTypes();
    }
  }, [userInfo]);

  useEffect(() => {
    if (loadSampleTableTypes) {
      fetchSampleTableTypes();
      setLoadSampleTableTypes(false);
    }
  }, [loadSampleTableTypes]);

  return [loading, error, setLoadSampleTableTypes];
}
